import { Box } from "@mui/material";

const Tab2 = ({ form }: { form?: any }) => {
    return (
        <Box sx={{ p: 2, textAlign: 'center', color: '#666' }}>
            Aucun financement à afficher
        </Box>
    );
};

export default Tab2;
